module.exports = __webpack_public_path__ + "static/media/chat-bubble.69ace404.svg";